import React from 'react'
import styled from 'styled-components'
import { Text } from 'app/common/typography'
import { CircleChecked } from 'app/assets/icons'
import { colors } from 'app-v2/design-systems/theme'
import { media } from 'app/assets/styles'
import { Picture } from 'app/common/picture'
import { formatPrice } from 'shared/utils'
import { SmallText } from 'app-v2/design-systems'
import { FormattedMessage } from 'react-intl'

type Props = {
    id: string,
    name?: string,
    imageUrl?: string,
    isSelected?: boolean,
    onOptionSelected: (isSelected: boolean) => void,
    price?: number
}

export const CatalogSelectableOption = ({
    name,
    imageUrl,
    isSelected,
    onOptionSelected,
    price
}: Props) => {
    return (
        <Widget onClick={() => !isSelected && onOptionSelected(!isSelected)}>
            <RowContainer>
                <RowContainerCenter>
                    <ContainerImage>
                        {imageUrl && (
                            <Picture singleImage imageUrl={[imageUrl]} />
                        )}
                    </ContainerImage>
                    <TextContainer>
                        {!!name && <Text>{name}</Text>}
                        {!!price && price !== 0 && (
                            <FormattedMessage
                                id="clickandcollect.catalog.stepper.price"
                                values={{
                                    price:
                                        price > 0
                                            ? `+${formatPrice(price)}`
                                            : `${formatPrice(price)}`
                                }}>
                                {(text: string) => (
                                    <SmallText>{text}</SmallText>
                                )}
                            </FormattedMessage>
                        )}
                    </TextContainer>
                </RowContainerCenter>
                <StyledCircleChecked
                    background={
                        isSelected ? colors.crunchyGreen : colors.lightGrey
                    }
                />
            </RowContainer>
        </Widget>
    )
}

const StyledCircleChecked = styled(CircleChecked)`
    width: 24px;
    height: 24px;
    ${media.medium`
        width: 30px;
        height: 30px;
    `};
`

const Widget = styled.div`
    display: block;
    background-color: white;
    border-radius: 10px;
    margin: 5px;
    justify-content: center;
    cursor: pointer;
`

const ContainerImage = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 70px;
`

const RowContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 5px 15px;
`

const RowContainerCenter = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 10px;
`

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding-left: 10px;
`
